import { useAxios } from "../Plugins/axios";
import { useRoute } from "../Plugins/ziggy";
export default class WeatherStationService {
    axios;
    route;
    constructor() {
        this.axios = useAxios();
        this.route = useRoute();
    }
    show(id) {
        return this.axios.get(this.route("admin.weather-stations.show", { id }));
    }
    store(data) {
        return this.axios.post(this.route("admin.weather-stations.store"), data);
    }
    update(id, data) {
        return this.axios.patch(this.route("admin.weather-stations.update", id), data);
    }
    delete(id) {
        const data = {
            _method: "DELETE",
        };
        return this.axios.post(this.route("admin.weather-stations.destroy", id), data);
    }
    deleteMultiple(ids) {
        const data = {
            _method: "DELETE",
            ids,
        };
        return this.axios.post(this.route("admin.weather-stations.destroy-multiple"), data);
    }
}
